import { MasterConfigContext } from "@/context/MasterConfigContext";
import {
  // apstagBidCallback,
  // createApsSlotsRosDesktop,
  // createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import dynamic from "next/dynamic";
import { useContext, useEffect } from "react";
const NewsGrid1 = dynamic(() => import("@/component/NewsGrid/NewsGrid1"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
// const BoardsFAQSchema = dynamic(() =>
//   import("@/component/SeoTags/BoardsFAQSchema")
// );
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));

const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

import SVG from "react-inlinesvg";

const BoardsResultWidget = ({
  isMobileDevice = false,
  topicNewsListData = null,
  tenthResult = false,
  faqData = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const boardsKeys = masterConfig["boards_result"];
  const boardsList = masterConfig["boardsList"];

  const breadCrumbs = [
    {
      id: "1",
      title: "शिक्षा",
      canonical_url: "/education",
      amp_url: "",
    },
    {
      id: "2",
      title: "बोर्ड रिजल्ट",
      canonical_url: "/education/board-results",
      amp_url: "",
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
        });
      }
      // apstag?.fetchBids(
      //   {
      //     slots:
      //       window.screen.width < 900
      //         ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
      //         : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
      //     timeout: 2e3,
      //   },
      //   apstagBidCallback
      // );
    }, 10);
  }, []);

  const title = "Board Results 2025 – Check All India 10th & 12th Results";

  const description = "Check 10th & 12th Board Results 2025 for UP, Jharkhand and MP Board Boards & more. Get direct links, mark sheets, and latest updates – all in one place.";
  const keywords = "Board Result 2025, 10th Result 2025, 12th Result 2025, CBSE Result 2025, State Board Result 2025, UP Board 10th, 12th results 2025, Jharkhand board result";

  return (
    <section className="w-full">
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          (tenthResult
            ? "/education/board-results/bseb-bihar-board-10th-result"
            : "/education/board-results/bseb-bihar-board-12th-result")
        }
        noAuthorTag={false}
        image={topicNewsListData?.seo_detail?.og_image}
        lcpImage={`${tenthResult
          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/boardsbg1-1.png"
          : "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/boardsbg12_inner.png"
          }`}
      />
      <GTMScript isElection={true} />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL + "/education/board-results"
        }
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />
      {/* <BoardsFAQSchema tenthResult={tenthResult} /> */}
      <ItemsList data={topicNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />

      <div className="mx-auto px-4">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
      <div className="mx-4 px-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
      </div>

      <div>
        <div className="hidden md:block">
          <div className="relative md:h-[100px] lg:h-[120px] w-full">
            <img
              src={"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_desktop_banner_10.png"}
              alt="Boards"
              width={900}
              height={200}
              layout="intrinsic"
              priority
              loading="eager"
              className="w-full my-4 z-0 h-auto"
            />
            <div className="absolute top-[40%] left-6 gap-0 z-10 font-semibold text-white">
              <h1 className="text-3xl">बोर्ड परीक्षा परिणाम 2025</h1>
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <div className="relative sm:h-[280px] lg:h-[160px] md:h-[160px] w-full">
            <img
              src={"https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/board_cat_banner_10.png"}
              alt="Boards"
              width={900}
              height={200}
              layout="intrinsic"
              priority
              loading="eager"
              className="w-full my-4 z-0 h-auto"
            />
            <div className="cursor-default absolute top-10 left-6 z-10 font-semibold text-white">
              <h1 className="flex flex-col items-start gap-0 text-3xl sm:text-5xl">
                <span>बोर्ड परीक्षा</span>
                <span>परिणाम 2025</span>
              </h1>
            </div>
          </div>
        </div>
        {/* results list  */}
        <div className="px-2 md:px-4 py-2 grid grid-cols-1 gap-4">
          {boardsList?.map((item, index) => {
            return (
              <div
                key={item.id}
                className={`w-full py-2 flex flex-col gap-2 items-start ${index != 0 ? 'border-t-8 border=[#F8F9FB]' : ''}`}
              >
                <div className="w-full flex items-center gap-2 border-l-8 border-primary px-4 py-2 bg-[#F8F9FB]">
                  {item.logo != "" && <img
                    src={item.logo}
                    alt={"boardlogo" + item.id}
                    width={30}
                    height={30}
                  />}
                  <h2 className="text-md md:text-lg font-semibold">{item.title}</h2>
                  <span
                    className={`${item.status == "Declared"
                      ? "text-green-500"
                      : "text-yellow-500"
                      }`}
                  >
                    {"(" + item.status + ")"}
                  </span>
                </div>
                {item.text1 && (
                  <a
                    href={item.link1}
                    className="ml-2 px-4 py-2 text-md w-fit rounded-lg shadow-md flex items-center gap-2"
                  >
                    <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rect1.svg" />
                    <p>{item.text1}</p>
                  </a>
                )}
                {item.text2 && (
                  <a
                    href={item.link2}
                    className="ml-2 px-4 py-2 text-md w-fit rounded-lg shadow-md flex items-center gap-2"
                  >
                    <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rect1.svg" />
                    <p>{item.text2}</p>
                  </a>
                )}
              </div>
            );
          })}
        </div>
        {/* news list */}
        {topicNewsListData &&
          topicNewsListData?.content?.length > 0 &&
          boardsKeys?.showNewsList && (
            <section className="px-3">
              <div className="flex items-center justify-between mt-8">
                <h2 className="flex mb-2 gap-2 items-center">
                  <span className="bg-[#CC0000] w-2 h-4"></span>
                  <span className="text-xl font-semibold">शिक्षा न्यूज</span>
                </h2>
                <a href="/education">
                  <span className="flex items-center text-lg">
                    और देखें
                    <SVG
                      className="w-6 h-6 inline ml-2  mt-[-2px]"
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrowRound.svg"
                    />
                  </span>
                </a>
              </div>
              <div className="text-16">
                <NewsGrid1
                  newsData={topicNewsListData || null}
                  showLiveVideo={false}
                  showAd={false}
                  isLCP={
                    boardsKeys?.showIframe10 || boardsKeys?.showIframe12
                      ? false
                      : true
                  }
                  isMobileDevice={isMobileDevice}
                  liveVideoData={null}
                  isResultsPage={true}
                />
              </div>
            </section>
          )}

        {/* description  */}
        <h2 className="px-3 flex mt-12 mb-2 gap-2 items-start">
          <span className="bg-[#CC0000] w-2 h-4"></span>
          <span className="text-xl font-semibold -mt-1">
            {"बोर्ड परीक्षा परिणाम"}
          </span>
        </h2>
        <p className="px-3 text-[#323232] text-sm text-left">
          Board Exam Results: CBSE, CISCE समेत अधिकतर स्टेट बोर्ड (State Board
          Exams) मार्च-अप्रैल तक बोर्ड परीक्षाएं आयोजित करा लेते हैं. परीक्षाएं
          खत्म होते ही छात्रों को अपने रिजल्ट का इंतजार होता है. छात्रों की
          सहूलियत के लिए newstak.in पर यूपी बोर्ड (UP Board), महाराष्‍ट्र बोर्ड
          (Maharashtra Board), राजस्‍थान बोर्ड (Rajasthan Board) समेत कई स्टेट
          बोर्ड के नतीजे उपलब्ध कराए जाते हैं. यहां स्टूडेंट्स आसानी से अपने
          स्कोर चेक कर सकते हैं. स्‍टूडेंट्स इस पेज पर आकर न सिर्फ अपने स्‍टेट
          बोर्ड रिजल्‍ट देख सकते हैं बल्कि रोल नंबर की मदद से अपनी मार्कशीट भी
          डाउनलोड कर सकते हैं. रिजल्‍ट की घोषणा के साथ ही डाउनलोड लिंक सबसे पहले
          इसी पेज पर लाइव हो जाता है.
        </p>

        {/* faqs  */}

        {/* {boardsKeys?.showFAQ && faqData && (
          <div className="px-3">
            <h2 className="flex mt-8 mb-2 gap-2 items-start">
              <span className="bg-[#CC0000] w-2 h-4"></span>
              <span className="text-xl font-semibold -mt-1">
                 {"बोर्ड परिणाम से जुड़े सवाल जवाब (FAQs)"}
              </span>
            </h2>
            <section className="mt-4 flex flex-col gap-4 text-gray-500 text-md font-extralight">
              <p
                className={`${isMobileDevice ? "custom-mb-break" : ""}`}
                dangerouslySetInnerHTML={{
                  __html: `${faqData?.content?.description_short}`,
                }}
              />
            </section>
          </div>
        )} */}
      </div>
      <div className="mx-4 px-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
    </section>
  );
};

export default BoardsResultWidget;
